import { createReducer, on } from '@ngrx/store';
import * as AuthActions from '../actions/auth.actions';
import { User } from '../../models/user';

export interface State {
  isAuthenticated: boolean;
  user: User | null;
  loading: boolean;
  errorMessage: string | null;
}

export const initialState: State = {
  isAuthenticated: false,
  user: null,
  loading: false,
  errorMessage: null
};

export const authReducer = createReducer(
  initialState,
  on(AuthActions.LogIn, (state) => ({
    ...state,
    loading: true,
    errorMessage: null
  })),

  on(AuthActions.LogInSuccess, (state, { user }) => ({
    ...state,
    isAuthenticated: true,
    user: { token: user.token, email: user.email },
    errorMessage: null,
    loading: false
  })),

  on(AuthActions.LogInFailure, (state) => ({
    ...state,
    errorMessage: 'Mot de passe ou adresse e-mail incorrecte.',
    loading: false
  })),

  on(AuthActions.SignUp, (state) => ({
    ...state,
    loading: true,
    errorMessage: null
  })),

  on(AuthActions.SignUpSuccess, (state, { token, email }) => ({
    ...state,
    isAuthenticated: true,
    user: { token:token, email: email },
    errorMessage: null,
    loading : false
  })),

  on(AuthActions.SignUpFailure, (state) => ({
    ...state,
    errorMessage: 'L\'adresse e-mail est déjà utilisée.',
    loading: false
  })),

  on(AuthActions.LogOut, () => initialState)
);
